import { render, staticRenderFns } from "./InlineEdit.vue?vue&type=template&id=54006984&"
import script from "./InlineEdit.vue?vue&type=script&lang=ts&"
export * from "./InlineEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports